import React, { useState } from 'react'
import { useTranslation } from '@sailor/i18n-web'
import FormPro from '@roo/roo/FormPro'
import Input from '@roo/roo/Input'
import Selector from '@roo/roo/Selector'
import Button from '@roo/roo/Button'
import { failToast, successToast } from '@/common/utils/toast'
import request from '@/common/api'
import { useRequest } from 'ahooks'
import { owlAddAjaxInfo } from '@/common/utils/owl'
import SectionContainer from '@/components/Container'
import Enterprise from '@/components/Enterprise'
import styles from './index.module.less'
import HighlightText from '@/components/HighlightText'


const Contact = () => {
  const { t } = useTranslation()
  const { run: handleSubmit, loading: submitLoading } = useRequest(async (formData: any) => {
    const requestParam = {
      email: formData.email,
      phoneNumber: formData.phone ?  `852_${formData.phone}` : '',
      firstName: formData.firstName,
      lastName: formData.lastName,
      useScene: Number(formData.usage),
      companyName: formData.company,
      companySize: Number(formData.size),
      leadType: 1,
    }
    const res = await request.post<{ msg: string }>('/api/web/leads/save', requestParam)
    owlAddAjaxInfo({
      name: '留资成功',
      msg: '留资成功',
      message: '留资成功',
    }, {
      // @ts-ignore
      requestParam: JSON.stringify(requestParam),
    })
    successToast(res?.msg || t('ent_o_contact_form_submitSuccess'))
  }, { manual: true })

  return (
    <SectionContainer style={{ width: '100%', paddingTop: '8.5rem' }}>
      <div style={{ width: '100%' }}>
        <div className="section-title" style={{ paddingBottom: '6.4rem' }}>
          <HighlightText>{t('ent_o_nav_contact', '联系我们')}</HighlightText>
        </div>
        <div className={styles.contentWraper}>
          <Enterprise />
          <div className={styles.formContainer}>
            <FormPro onFinish={handleSubmit} layout="vertical"  requiredMark={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              onFinishFailed={() => {
                failToast(t('ent_o_contact_form_validation_incorrectInfo'))
              }}>
              <FormPro.Item
                label={t('ent_o_contact_form_firstName')}
                name="firstName"
                needLabel={false}
                rules={[
                  {
                    required: true,
                    message: t('ent_o_contact_form_validation_required'),
                  },
                ]}
              >
                <Input type="text" placeholder={t('ent_o_contact_form_placeholder')} />
              </FormPro.Item>
              <FormPro.Item
                label={t('ent_o_contact_form_lastName')}
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: t('ent_o_contact_form_validation_required'),
                  },
                ]}
              >
                <Input type="text" placeholder={t('ent_o_contact_form_placeholder')} />
              </FormPro.Item>
              <FormPro.Item
                label={t('ent_o_contact_form_email')}
                name="email"
                rules={[
                  {
                    required: true,
                    message: t('ent_o_contact_form_validation_required'),
                  },
                  {
                    type: 'email',
                    message: t('ent_o_contact_form_validation_invalidEmail'),
                  },
                ]}
              >
                <Input type="email" placeholder={t('ent_o_contact_form_placeholder')} />
              </FormPro.Item>
              <FormPro.Item
                label={t('ent_o_contact_form_phone_label')}
                name="phone"
                // normalize函数是将FORM表单的值进行处理，例如trim、replace等，最后将处理后的值return回去
                // 这里remove掉所有的空格
                normalize={(value) => value.replace(/\s/g, '')}
                rules={[
                  {
                    pattern: /^\d{8}$/, // 香港电话号码，固定8位
                    message: t('ent_o_contact_form_phone_invalidPhone'),
                  },
                ]}
              >
                <Input type="tel" placeholder={t('ent_o_contact_form_placeholder')}
                  preAppend="+852"
                />
              </FormPro.Item>
              <FormPro.Item
                label={t('ent_o_contact_form_company')}
                name="company"
                rules={[
                  {
                    required: true,
                    message: t('ent_o_contact_form_validation_required'),
                  },
                ]}
              >
                <Input type="text" placeholder={t('ent_o_contact_form_placeholder')} />
              </FormPro.Item>
              <FormPro.Item
                label={t('ent_o_contact_form_size_label')}
                name="size"
                rules={[
                  {
                    required: true,
                    message: t('ent_o_contact_form_validation_required'),
                  },
                ]}
              >
                <Selector
                  placeholder={t('ent_o_contact_form_usage_placeholder')}
                  options={[
                    { value: '1', label: t('ent_o_contact_form_size_options_1') },
                    { value: '2', label: t('ent_o_contact_form_size_options_2') },
                    { value: '3', label: t('ent_o_contact_form_size_options_3') },
                    { value: '4', label: t('ent_o_contact_form_size_options_4') },
                    { value: '5', label: t('ent_o_contact_form_size_options_5') },
                  ]}
                />
              </FormPro.Item>
              <FormPro.Item
                label={t('ent_o_contact_form_usage_label')}
                name="usage"
                rules={[
                  {
                    required: true,
                    message: t('ent_o_contact_form_validation_required'),
                  },
                ]}
              >
                <Selector
                  placeholder={t('ent_o_contact_form_usage_placeholder')}
                  placement="top"
                  optionRenderer={(normalized: { value: number | string; label: string; disabled?: boolean }) => (
                    <div style={{ whiteSpace: 'pre-wrap', lineHeight: '1.5', display: 'flex', alignItems: 'center', minHeight: '36px' }} >
                      {normalized.label}
                    </div>
                  )}
                  options={[
                    { value: '1', label: t('ent_o_contact_form_usage_options_1') },
                    { value: '2', label: t('ent_o_contact_form_usage_options_2') },
                    { value: '3', label: t('ent_o_contact_form_usage_options_3') },
                    { value: '4', label: t('ent_o_contact_form_usage_options_4') || '企業專屬福利合作' },
                  ]}
                />
              </FormPro.Item>
              <div  className={styles.submitContainer}>
                <Button loading={submitLoading} disabled={submitLoading} htmlType="submit"
                  className="submit-btn"
                  type="brand" >
                  {t('ent_o_contact_form_submit')}
                </Button>
              </div>
            </FormPro>
          </div>
        </div>
      </div>
    </SectionContainer>
  )
}
export default Contact
